var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"mt-5"},[_c('ae-text-field',{attrs:{"label":"lot.name","required":true,"disabled":!_vm.editable},model:{value:(_vm.lotSync.name),callback:function ($$v) {_vm.$set(_vm.lotSync, "name", $$v)},expression:"lotSync.name"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }